(function () {
  'use strict';

  $(function () {
    showOrHideEntityFields();
    $('input[type=radio]:checked').trigger('click');
    $('specific_account').trigger('click');

    let driver = $('[name="driver"]').val();
    if (driver) {
      changeHybridSpecificAccountField(driver);
    }
  });

  function showOrHideEntityFields() {
    $('.custom-radio').on('click', function () {
      let $radio = $(this).find('input[type="radio"]');
      let $all = $('input[type="radio"][name="' + $radio.prop('name') + '"]');
      $all.removeProp('checked', 'checked');
      $radio.prop('checked', 'checked');

      changeLegalOrIndividualEntityInputs($radio);
      changeSpecificAccountField($radio);
      changeMatrixField($radio);
    });

    $('#specific_account').on('click', (event) => {
      changeHybridSpecificAccountField($(event.target).val());
    })
  }

  function changeMatrixField($radio) {
    if (radioDataIsEqualValue($radio, 'branch')) {
      showField('[data-matrix]');
    } else if (radioDataIsEqualValue($radio, 'matrix')) {
      hideField('[data-matrix]');
    }
  }

  function changeSpecificAccountField($radio) {
    if (radioDataIsEqualValue($radio, 'is_specific_account')) {
      showField('[data-specific_account]');
      changeHybridSpecificAccountField($('#specific_account').val());

    } else if (radioDataIsEqualValue($radio, 'is_not_specific_account')) {
      hideField('[data-specific_account]');
      changeHybridSpecificAccountField();
    }
  }

  function changeHybridSpecificAccountField(accountType = undefined) {
    if (accountType == 'magazineluiza') {
      showField('[data-is-hybrid]');
    } else {
      hideField('[data-is-hybrid]');
    }
  }

  function changeLegalOrIndividualEntityInputs($radio) {
    if (radioDataIsEqualValue($radio, 'individual-entity')) {
      changeIndividualEntityForm();
    } else if (radioDataIsEqualValue($radio, 'legal-entity')) {
      changeLegalEntityForm();
    }
  }

  function radioDataIsEqualValue($radio, value) {
    return $radio.data('checkbox') == value;
  }

  function changeIndividualEntityForm() {
    showField('[data-individual-entity]');
    hideField('[data-legal-entity]');
    hideField('[data-matrix]');
    changeLabelName('Nome');
  }

  function changeLegalEntityForm() {
    hideField('[data-individual-entity]');
    showField('[data-legal-entity]');
    const matrixCheckbox = $('input[data-checkbox="matrix"]:checked').attr('id');
    if (matrixCheckbox !== 'matrix') {
      showField('[data-matrix]');
    }
    changeLabelName('Razão social');
  }

  function showField(data) {
    $(data).show();
  }

  function hideField(data) {
    $(data).hide();
  }

  function changeLabelName(name) {
    $('#name').text(name);
  }
})();



// WEBPACK FOOTER //
// ./resources/assets/js/accounts/accounts.js